import './MapleService.ts';
import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { SettingsProvider } from '@maple-tech/web-components/settings';
import ThemeProvider from '@maple-tech/web-components/theme';
import { Footer, Header } from './Footer.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Box, Stack } from '@mui/material';
// @ts-ignore
import { registerSW } from 'virtual:pwa-register';
console.log('registerSW', registerSW);
registerSW({ immediate: true });
const queryClient = new QueryClient();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'dark', // 'light' | 'dark'
          themeDirection: 'ltr', //  'rtl' | 'ltr'
          themeContrast: 'default', // 'default' | 'bold'
          themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          themeStretch: false,
          themeCorner: 'rounded', // 'rounded' | 'squared'
          themePaperVariant: 'outlined',
          themeSpacing: 'compact',
        }}
      >
        <ThemeProvider>
          <Stack sx={{ minHeight: '100vh' }}>
            <Header />
            <App />
            <Box sx={{ flexGrow: 1 }} />
            <Footer />
          </Stack>
        </ThemeProvider>
      </SettingsProvider>
    </QueryClientProvider>
  </StrictMode>,
);
